module.exports = __webpack_public_path__ + "img/h4.f63e6d79.jpg";